module.exports = __webpack_public_path__ + "img/20.f9e3c49e.jpg";